import { ReactElement, ReactNode } from 'react';
import {
  Text,
  TextTag,
  TokenTextAppearance,
  TokenTextColor,
} from '@volkswagen-onehub/components-core';

import { StyledMessage, StyledPhone, StyledRotateDevicePrompt } from './RotateDevicePrompt.styles';

type RotateDevicePromptProps = {
  message: ReactNode;
};

const RotateDevicePrompt = ({ message }: RotateDevicePromptProps): ReactElement => {
  return (
    <StyledRotateDevicePrompt role="status" aria-live="polite" data-testid="rotate-device-prompt">
      <StyledPhone aria-hidden />

      <StyledMessage>
        <Text
          tag={TextTag.p}
          appearance={TokenTextAppearance.copy200}
          color={TokenTextColor.inherit}
        >
          {message}
        </Text>
      </StyledMessage>
    </StyledRotateDevicePrompt>
  );
};

export default RotateDevicePrompt;
